// removed by extract-text-webpack-plugin
module.exports = {"waiting":"style__waiting-2jYxP","spin":"style__spin-pwJbw","antIcon":"style__antIcon-36tKM"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Welcome/style.less
// module id = 648
// module chunks = 17